import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function FawryPayment() {
    const location = useLocation();
    const navigate = useNavigate();
    const { fawryResponse } = location.state || {};

    if (!fawryResponse?.invoice?.payment_data) {
        return <p className="text-danger text-center">لم يتم استلام بيانات فوري</p>;
    }

    const { fawryCode, expireDate } = fawryResponse.invoice.payment_data;

    // تقسيم التاريخ والوقت
    const [date, time] = expireDate.split(" ");

    return (
        <div className="d-flex justify-content-center align-items-center bg-light "
            style={{ minHeight: "70vh" }}>
            <div className="card shadow-lg p-4 w-100 text-center rounded-3" dir="rtl" style={{ maxWidth: "500px" }}>
                <h3 className="mb-3">الدفع من خلال فوري</h3>

                <p className="fs-5 mb-2">
                    <b className="main-color">كود فوري:</b> {fawryCode}
                </p>

                <p className="text-muted">برجاء التوجه لأقرب منفذ فوري واستخدام هذا الكود للدفع.</p>

                <p className="text-muted mb-3 ">
                    <span className="fw-bold">صالح حتى:</span>
                    <br />
                    📅 {date}
                    <br />
                    ⏰ {time}
                </p>

                <p
                    className="mb-4 text-secondary text-center "
                    style={{ fontSize: "20px", fontWeight: "600" }}>
                    سيظهر طلبك في صفحة الطلبات بعد إتمام عملية الدفع.
                </p>

                <button
                    className="btn btn-new-color w-100"
                    onClick={() => navigate("/allOrderLoggedUser")}
                >
                    الذهاب إلى الطلبات
                </button>
            </div>
        </div>
    );
}
